/** 用户协议 */
<template>
  <div class="home protocol-home">
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column label="动态">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.type == 'WatchEvent'">
             <a target="_black" :href="'https://github.com/' + scope.row.actor.login">{{scope.row.actor.login}}</a> &nbsp;
             <span >starred</span> &nbsp;
             <a target="_black" :href="'https://github.com/' + scope.row.repo.name">{{scope.row.repo.name}}</a> &nbsp;
          </div>

          <div v-if="scope.row.type == 'ForkEvent'">
             <a target="_black" :href="'https://github.com/' +  scope.row.actor.login">{{scope.row.actor.login}}</a> &nbsp;
             <span>forked</span> &nbsp;
             <a target="_black" :href="'https://github.com/' + scope.row.repo.name">{{scope.row.repo.name}}</a> &nbsp;
          </div> -->

          <!-- id: item.split('&')[0],
            type: item.split('&')[1],
            login: item.split('&')[2],
            time: item.split('&')[3],
            url
          </div> -->

          <div v-if="scope.row && scope.row.type == 'PushEvent'">
            <a
              target="_black"
              :href="'https://github.com/' +  scope.row.login"
            >{{scope.row.login}}</a> &nbsp;
            <span>pushed to </span> &nbsp;
            <a
              target="_black"
              :href="scope.row.url"
            >{{scope.row.url}}</a> &nbsp;
          </div>

          <div v-if="scope.row.type == 'CreateEvent'">
            <a
              target="_black"
              :href="'https://github.com/' +  scope.row.login"
            >{{scope.row.login}}</a> &nbsp;
            <span>created</span>
            <a
              target="_black"
              :href="scope.row.url"
            >{{scope.row.url}}</a> &nbsp;
          </div>

          <!-- <span v-if="scope.row.type == 'CreateEvent'">创建了</span>
          <span v-if="scope.row.type == 'ForkEvent'">Fork了</span>
          <span v-if="scope.row.type == 'PushEvent'">Push 了</span> -->
          <!-- <el-button type="text" size="small">查看</el-button> -->
          <!-- <el-button type="text" size="small">编辑</el-button> -->
        </template>
      </el-table-column>
      <!-- 时间 -->
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{scope.row.time}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Layout from "@/components/DatePanel/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { mapActions, mapState } from "vuex";
import Footer from "@/components/Common/Footer.vue";
import moment from "moment";

export default {
  name: "home",
  //   getInfo
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    ...mapActions([
      "getInfo",
      // "getOneConfig"
    ]),
  },
  created() {
    this.getInfo().then((item) => {
      if (item.data.length) {
        let newList = item.data.map(item => {
          // if (item && item.length) {
            return {
              id: item.split("&")[0],
              type: item.split("&")[1],
              login: item.split("&")[2],
              time: moment(item.split("&")[3]).format("YYYY-MM-DD hh:mm"),
              timestamp: moment(item.split("&")[3]).valueOf(),
              url: item.split("&")[4],
            };
          // }
        });

        newList.sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
        this.tableData = newList;
      }
    });
  },
};
</script>

<style  lang="stylus"></style>
